import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleContentPermissionsComponent } from './role-content-permissions.component';

const routes: Routes = [
  {
    path: '',
    component: RoleContentPermissionsComponent
  },
  {
    path: ':id',
    component: RoleContentPermissionsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoleContentPermissionsRoutingModule { }
